<template>
  <div class="page-site-pages">
    <app-page-box title="官网页面">
      <el-table class="page-site-pages__table" :data="pages" border style="width: 100%">
        <el-table-column label="页面名称" prop="label"></el-table-column>
        <el-table-column label="当前状态" prop="status"></el-table-column>
        <el-table-column label="使用模板" prop="theme"></el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleEditPage(scope.row.name)" :disabled="!scope.row.editable">编辑</el-button>
            <el-button type="text" size="small" @click="handleViewPage(scope.row.name)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
    </app-page-box>
  </div>
</template>

<script>
import AppPageBox from '@/components/AppPageBox'

const { VUE_APP_CLOUD_SITE_SERVER } = process.env
// const pagesMap = {
//   1: { name: 'index', theme: '默认模板', editable: true },
//   2: { name: 'products', theme: '默认模板', editable: false },
//   3: { name: 'productDetail', theme: '默认模板', editable: false },
//   4: { name: 'articles', theme: '默认模板', editable: false },
//   5: { name: 'articleDetail', theme: '默认模板', editable: true },
//   6: { name: 'cases', theme: '默认模板', editable: false },
//   7: { name: 'about', theme: '默认模板', editable: true }
// }

export default {
  name: 'page-site-pages',
  components: {
    AppPageBox
  },

  data () {
    return {
      pages: [
        { name: 'index', label: '首页', status: '使用中', theme: '默认模板', editable: true },
        { name: 'articleDetail', label: '资讯详情', status: '使用中', theme: '默认模板', editable: true },
        { name: 'about', label: '关于我们', status: '使用中', theme: '默认模板', editable: true },
        { name: 'products', label: '产品与服务', status: '使用中', theme: '默认模板', editable: false },
        { name: 'articles', label: '资讯动态', status: '使用中', theme: '默认模板', editable: false },
        { name: 'cases', label: '合作案例', status: '使用中', theme: '默认模板', editable: false }
      ]
    }
  },

  computed: {
    user () {
      return this.$store.state.account.user
    },

    article () {
      const detail = this.$store.state.article.detail
      return detail.list[0]
    }
  },

  created () {
    this.getSiteThemeConfig()
    if (!this.article) {
      this.getArticles()
    }
  },

  methods: {
    // 获取主题配置
    getSiteThemeConfig () {
      this.$store.dispatch('getSiteThemeConfig', {
        params: { userId: this.user.id }
      })
    },

    // 获取文章列表
    getArticles () {
      this.$store.dispatch('getArticleDetails', {
        params: { userId: this.user.id },
        query: {
          status: [ 5, 105 ],
          offset: 0,
          limit: 10
        }
      })
    },

    // 处理编辑页面
    handleEditPage (name) {
      this.$router.push({ name: 'SiteEditor', query: { name } })
    },

    // 处理查看页面
    handleViewPage (name) {
      if (name === 'articleDetail') {
        window.open(`${VUE_APP_CLOUD_SITE_SERVER}/a${this.article.id}`)
        return
      }

      window.open(`${VUE_APP_CLOUD_SITE_SERVER}/u/${this.user.id}/${name}`)
    }
  }
}
</script>

<style lang="scss">
.page-site-pages {
  min-height: 100%;
  background-color: #fff;

  &__table th {
    background-color: #f8f8f8;
  }
}
</style>
